export default __webpack_public_path__ + "d5e2793.png";